import i18n from '../../../../i18n';

const operators = [
  {id: 'and', label: i18n.t('sessionSearch.queryList.operators.and')},
  {id: 'or', label: i18n.t('sessionSearch.queryList.operators.or')},
  {id: 'not', label: i18n.t('sessionSearch.queryList.operators.not')},
  {
    id: 'open',
    label: i18n.t('sessionSearch.queryList.operators.openParenthesis'),
  },
  {
    id: 'close',
    label: i18n.t('sessionSearch.queryList.operators.closeParenthesis'),
  },
];

export const getOperators = () => operators;

export const getOperatorLabel = (id: string): string | null => {
  const operator = operators.find((value) => value.id === id);
  if (operator) {
    return operator.label;
  }
  return null;
};

export const getOperatorId = (label: string): string | null => {
  const operator = operators.find((value) => value.label === label);
  if (operator) {
    return operator.id;
  }
  return null;
};
